<template>
  <div>
    <Head title="Waste Receipts" />
    <h1 class="mb-8 text-3xl font-bold">Waste Receipts</h1>
    <hr />
    <ul
      id="tabs-tabFill"
      class="nav nav-tabs flex flex-col md:flex-row flex-wrap list-none border-b-0 pl-0 mb-4"
      role="tablist"
    >
      <li class="nav-item flex-auto text-center" role="presentation">
        <a
          id="tabs-daysReceipts-tabFill"
          href="#tabs-daysReceiptsFill"
          class="
          nav-link
          w-full
          block
          font-medium
          text-xs
          leading-tight
          uppercase
          border-x-0 border-t-0 border-b-2 border-transparent
          px-6
          py-3
          my-2
          hover:border-transparent hover:bg-gray-100
          focus:border-transparent
          active" 
          data-bs-toggle="pill" 
          data-bs-target="#tabs-daysReceiptsFill" 
          role="tab"
          aria-controls="tabs-daysReceiptsFill"
          aria-selected="true"
        >
          Today's Receipts
        </a>
      </li>
      <li class="nav-item flex-auto text-center" role="presentation">
        <a 
          id="tabs-allReceipts-tabFill"
          href="#tabs-allReceiptsFill"
          class="
          nav-link
          w-full
          block
          font-medium
          text-xs
          leading-tight
          uppercase
          border-x-0 border-t-0 border-b-2 border-transparent
          px-6
          py-3
          my-2
          hover:border-transparent hover:bg-gray-100
          focus:border-transparent"
          data-bs-toggle="pill"
          data-bs-target="#tabs-allReceiptsFill"
          role="tab"
          aria-controls="tabs-allReceiptsFill"
          aria-selected="false"
        >
          All Receipts
        </a>
      </li>
      <li
        class="nav-item flex-auto text-center"
        role="presentation"
      >
        <a
          id="tabs-summary-tabFill"
          href="#tabs-summaryFill"
          class="
          nav-link
          w-full
          block
          font-medium
          text-xs
          leading-tight
          uppercase
          border-x-0 border-t-0 border-b-2 border-transparent
          px-6
          py-3
          my-2
          hover:border-transparent hover:bg-gray-100
          focus:border-transparent"
          data-bs-toggle="pill"
          data-bs-target="#tabs-summaryFill"
          role="tab"
          aria-controls="tabs-summaryFill"
          aria-selected="false"
        >
          Summaries
        </a>
      </li>
    </ul>
    <div id="tabs-tabContentFill" class="tab-content">
      <div id="tabs-daysReceiptsFill" class="tab-pane fade show active" role="tabpanel" aria-labelledby="tabs-daysReceipts-tabFill">
        <div class="bg-white rounded-md shadow overflow-x-auto mt-5">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-2 pt-2 px-3">Date</th>
              <th class="pb-2 pt-2 px-3">Part Number</th>
              <th class="pb-2 pt-2 px-3">Description</th>
              <th class="pb-2 pt-2 px-3">Quantity</th>
              <th class="pb-2 pt-2 px-3">UoM</th>
            </tr>
            <tr v-for="item in receipts.data" :key="item.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
              <td class="border-t">
                <Link class="flex items-center px-3 py-2 focus:text-orange-500">
                  {{ item.date }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.part_no }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.description }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.quantity }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.unit_of_measure }}
                </Link>
              </td>
            </tr>
            <tr v-if="receipts.data.length === 0">
              <td class="px-3 py-3 border-t" colspan="6">No data found</td>
            </tr>
          </table>
        </div>
        <pagination class="mt-6" :links="receipts.links" />
      </div>
      <div id="tabs-allReceiptsFill" class="tab-pane fade" role="tabpanel" aria-labelledby="tabs-allReceipts-tabFill">
        <div class="flex items-center justify-between mb-6">
          <date-range v-model="search.dateValue" class="mr-0 w-full max-w-md mr-3" @reset="reset" />
          <a
            v-if="all_receipts.data.length > 0"
            class="btn-orange px-3 py-2 text-xs cursor-pointer"
            :href="`/waste/receipts/download/${search.dateValue}`"
            download
            target="__blank"
          >
            <span>Download</span>
          </a>
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto mt-5">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-2 pt-2 px-3">Date</th>
              <th class="pb-2 pt-2 px-3">Part Number</th>
              <th class="pb-2 pt-2 px-3">Description</th>
              <th class="pb-2 pt-2 px-3">Quantity</th>
              <th class="pb-2 pt-2 px-3">UoM</th>
            </tr>
            <tr v-for="item in all_receipts.data" :key="item.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
              <td class="border-t">
                <Link class="flex items-center px-3 py-2 focus:text-orange-500">
                  {{ item.date }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.part_no }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.description }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.quantity }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.unit_of_measure }}
                </Link>
              </td>
            </tr>
            <tr v-if="all_receipts.data.length === 0">
              <td class="px-3 py-3 border-t" colspan="6">No data found</td>
            </tr>
          </table>
          <pagination class="mt-6" :links="all_receipts.links" />
        </div>
      </div>
      <div id="tabs-summaryFill" class="tab-pane fade" role="tabpanel" aria-labelledby="tabs-summary-tabFill">
        <div class="flex items-center justify-between mb-6">
          <date-range v-model="summary.dateRange" class="mr-0 w-full max-w-md" @reset="resets" />
          <a
            v-if="summaries.data.length > 0"
            class="btn-orange px-3 py-2 text-xs cursor-pointer"
            :href="`/waste/receipts/summaries/download/${summary.dateRange}`"
            download
            target="__blank"
          >
            <span>Download</span>
          </a>
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto mt-5">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-2 pt-2 px-3">Part Number</th>
              <th class="pb-2 pt-2 px-3">Part Description</th>
              <th class="pb-2 pt-2 px-3">Category</th>
              <th class="pb-2 pt-2 px-3">Quantity</th>
              <th class="pb-2 pt-2 px-3">UoM</th>
            </tr>
            <tr
              v-for="item in summaries.data"
              :key="item.id"
              class="hover:bg-orange-100 focus-within:bg-gray-100"
            >
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.sku_name }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.description }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.category }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.quantity }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.unit_of_measure }}
                </Link>
              </td>
            </tr>
            <tr v-if="summaries.data.length === 0">
              <td class="px-3 py-3 border-t" colspan="6">No data found</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import TextInput from '@/Shared/TextInput'
import DateRange from '@/Shared/DateRange'
import LoadingButton from '@/Shared/LoadingButton'
import Pagination from '@/Shared/Pagination'
import axios from 'axios'

export default {
  components: {
    Head,
    Link,
    TextInput,
    LoadingButton,
    Pagination,
    DateRange,
  },
  layout: Layout,
  props: {
    filters: Object,
    receipts: Object,
    all_receipts: Object,
    summaries: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        item_id: null,
        value: null,
      }),
      measurePcs: 'PCS',
      itemObj: [],
      msgStr: '',
      search: {
        dateValue: this.filters.dateValue,
      },
      summary: {
        dateRange: this.filters.dateRange,
      },
    }
  },
  computed: {
    confirmItem() {
      return this.itemObj || []
    },
    role() {
      return this.$inertia.page.props.auth.user.role
    },
  },
  watch: {
    search: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/waste-receipts/', pickBy(this.search), { preserveState: true })
      }, 150),
    },
    summary: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/waste-receipts/', pickBy(this.summary), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.search = mapValues(this.search, () => null)
    },
    resets() {
      this.summary = mapValues(this.summary, () => null)
    },
  },
}
</script>
